<template>
  <v-chip
    v-if="status !== 'follows_store'"
    x-small
    label
    outlined
    :color="color"
    class="branch-status-chip"
  >
    <v-icon x-small left>{{ icon }}</v-icon>
    {{ $t("branch_status_" + status) }}
  </v-chip>
</template>

<script>
import { branchStatus } from "@/utils/branchStatus";

const STYLE = {
  active: { color: "grey", icon: "fal fa-check-circle" },
  expiring: { color: "warning", icon: "fal fa-clock" },
  expired: { color: "error", icon: "fal fa-ban" },
};

export default {
  name: "BranchStatusChip",
  props: {
    branch: { type: Object, default: null },
  },
  computed: {
    status() {
      return branchStatus(this.branch);
    },
    color() {
      return (STYLE[this.status] || STYLE.active).color;
    },
    icon() {
      return (STYLE[this.status] || STYLE.active).icon;
    },
  },
};
</script>
